import React, { Fragment } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { RecoilRoot } from "recoil";
import { withRouter } from "react-router-dom";

import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";

import accountSchema from "./schema/account";
import util from "../../../global/utils/Helpers";

import { fetchUserData } from "../../../global/app/actions/actions_fetchUsers";
import { store } from "../../../global/app/store";

class EditAccountModal extends React.Component {
  // componentDidMount() {}

  accountQuery = async (query) => {
    let apiIndex = util.isLocalhost()
      ? "http://localhost:9393/auth/graphql"
      : `${util.getCurrentHost()}/auth/auth/graphql`;
    const opts = {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query }),
    };

    const data = await fetch(apiIndex, opts)
      .then((res) => {
        store.dispatch(fetchUserData());
        return res.json();
      })
      .then((data) => {
        return data;
      });

    return data;
  };

  handleSave = (values) => {
    let query = `mutation {
  			updateAttributes(
          accepted_rules_of_behavior:true,
          account_type:"${values.account_type}",
  			  last_name:"${values.last_name}",
  			  first_name:"${values.first_name}",
  			  phone_number:"${values.phone_number}",
  			  extension:"${values.phone_number_ext}",
  			  legal_business_name:"${values.legal_bussiness_name}",
  			  federal_employer_identification: "${values.fein}"
  			)}`;
    this.accountQuery(query);
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.props.history.push("/dashboard/myaccount");
  };

  render() {
    const { user, modalIsOpen, closeEditModal } = this.props;

    const modalStyles = {
      content: {
        width: "100%",
        height: "100%",
        margin: "0",
        padding: "20px",
        position: "absolute",
        borderRadius: "0",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
      },
    };

    const closeButton = {
      position: "absolute",
      right: "20px",
      top: "20px",
      background: "none",
      border: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
    };

    const formStyles = {
      flexBasis: "50%",
    };

    return (
      <Fragment>
        <Modal
          style={modalStyles}
          isOpen={modalIsOpen}
          onRequestClose={closeEditModal}
          overlayClassName="Overlay"
        >
          <button
            style={closeButton}
            onClick={() => {
              closeEditModal();
            }}
            type="button"
          >
            <MdClose style={closeButtonIcon} />
          </button>
          <div className="grid-row profile-modal-content">
            <RecoilRoot>
              <SimpleForm
                uiSchema={accountSchema}
                inputResolver={inputResolver}
                handleSave={this.handleSave}
                initialValues={user}
                formStyles={formStyles}
                closeModal={closeEditModal}
              />
            </RecoilRoot>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(EditAccountModal);
